"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MonetaryInput = void 0;
const react_1 = __importStar(require("react"));
const utils_1 = require("../../lib/utils");
const text_input_1 = __importDefault(require("./text-input"));
const parseValue = (allowDecimal, currencySymbol, symbolPosition, value, locales) => {
    // keep only number characters, and strip leading zeroes
    const normalizedValue = typeof value === 'number' ? value.toFixed(allowDecimal ? 2 : 0) : value;
    const cleanValue = normalizedValue.replace(/[^0-9]/g, '').replace(/^0*/g, '');
    let parsedNumber = Number.parseInt(cleanValue, 10) || 0;
    if (allowDecimal) {
        parsedNumber /= 100;
    }
    const digits = allowDecimal ? 2 : 0;
    const formattedNumber = parsedNumber.toLocaleString(locales, {
        minimumFractionDigits: digits,
    });
    const leftSymbol = symbolPosition === 'left' ? currencySymbol : '';
    const rightSymbol = symbolPosition === 'right' ? currencySymbol : '';
    const formattedValue = `${leftSymbol}${formattedNumber}${rightSymbol}`;
    return [parsedNumber, formattedValue];
};
const MonetaryInput = (_a) => {
    var { value = '', onChange = utils_1.noop, onBlur = utils_1.noop, onFocus = utils_1.noop, onKeyDown = utils_1.noop, onKeyUp = utils_1.noop, onClick = utils_1.noop, placeholder = '', currencySymbol = '$', symbolPosition = 'left', allowDecimal = false, maxValue = 999999999999999, locales, valid = false, hint, icon = null, iconPosition = 'right' } = _a, props = __rest(_a, ["value", "onChange", "onBlur", "onFocus", "onKeyDown", "onKeyUp", "onClick", "placeholder", "currencySymbol", "symbolPosition", "allowDecimal", "maxValue", "locales", "valid", "hint", "icon", "iconPosition"]);
    const parse = react_1.useCallback((val) => {
        if ((val === '' || val === currencySymbol) && !!placeholder) {
            // Allow placeholder to be displayed.
            return [0, ''];
        }
        return parseValue(allowDecimal, currencySymbol, symbolPosition, val, locales);
    }, [allowDecimal, currencySymbol, symbolPosition, locales, placeholder]);
    const [[, formattedValueState], setValue] = react_1.useState(parse(value));
    react_1.useEffect(() => {
        const parsedValues = parse(value);
        setValue(parsedValues);
    }, [parse, value]);
    const handleChange = (newValue, e) => {
        const [parsedNewValue, formattedNewValue] = parse(newValue);
        if (maxValue && parsedNewValue > maxValue) {
            // Restore previous value in case value was already updated (for Preact)
            e.target.value = formattedValueState;
            return;
        }
        if (formattedNewValue !== formattedValueState) {
            setValue([parsedNewValue, formattedNewValue]);
            onChange(formattedNewValue, parsedNewValue);
        }
        // Move the cursor to the end of the numbers, regardless of currency symbol and position
        const element = e.target;
        const cursor = formattedNewValue.search(/[0-9][^0-9]*$/) + 1;
        window.requestAnimationFrame(() => {
            element.selectionStart = cursor;
            element.selectionEnd = cursor;
        });
        // needed for preact which doesn't rerender if state is identical
        element.value = formattedNewValue;
    };
    return (react_1.default.createElement(text_input_1.default, Object.assign({ type: "text", value: formattedValueState, onChange: handleChange, onBlur: onBlur, onFocus: onFocus, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onClick: onClick, placeholder: placeholder, valid: valid, hint: hint, icon: icon, iconPosition: iconPosition }, props)));
};
exports.MonetaryInput = MonetaryInput;
exports.default = exports.MonetaryInput;
